import React, { useState, useContext, useEffect } from 'react';
import { shape, string, array } from 'prop-types';
import InputSelector from './ProFlowInputSelector';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Section } from 'wg-fe-ui';
import { ProFlowStorageContext } from '../services/context/ProFlowStorageContext';

const ProFlowQuestionsTrailer = ({
  taggedQuestions,
  allQuestions,
  tag,
  questionErrors,
}) => {
  const [trailerList, setTrailerList] = useState([]);
  const { answers } = useContext(ProFlowStorageContext);
  const { i18n } = useTranslation();

  const fullWidthSpans = [];
  const thirdWidthSpans = [];
  const halfSpanLonely = [];

  function getSpanLenght(id) {
    if (fullWidthSpans.includes(id) || halfSpanLonely.includes(id)) return 6;
    if (thirdWidthSpans.includes(id)) return 2;
    return 3;
  }

  function getElementwidth(id) {
    if (halfSpanLonely.includes(id)) return 'calc(50% - 10px);';
  }

  useEffect(() => {
    filterSteps();
  }, [answers]);

  function filterSteps() {
    const requiredAnswers = filterRequiredAnswers();
    const trailerList = filterNumberOfTrailers(requiredAnswers);
    setTrailerList(trailerList);
  }

  function filterRequiredAnswers() {
    return taggedQuestions.filter(question => {
      const { required } = question;

      return showCriteria(required, answers);
    });
  }

  function showCriteria(required = [], _answers = []) {
    // show input if nothing is required
    if (required.length === 0) return true;
    const nulledRequires = required.filter(({ answer }) => answer === null);
    const generalRequires = required.filter(({ answer }) => answer !== null);

    const shouldShowQuestion =
      areAllNulledQuestionsAnswered(nulledRequires, answers) ||
      isOneOfQeneralQuestionsAnswered(generalRequires, answers);

    return shouldShowQuestion;
  }

  function areAllNulledQuestionsAnswered(required = [], _answers = []) {
    // if there are no nulled questions return true
    if (required.length === 0) return false;

    // return true if all nulled questions are answered
    return required
      .map(({ id }) => _answers.some(({ id: _id }) => id === _id))
      .includes(false);
  }

  function isOneOfQeneralQuestionsAnswered(required = [], _answers = []) {
    // if there are no questions return true
    if (required.length === 0) return false;
    // return true if id and answer matches
    return required.some(require =>
      _answers.some(
        ({ id, answer }) => require.id === id && answer === require.answer,
      ),
    );
  }

  function filterNumberOfTrailers(_taggedQuestions) {
    const trailerIndex = new Set(_taggedQuestions.map(({ index }) => index));
    return [...trailerIndex].map(_index =>
      _taggedQuestions.filter(({ index }) => index === _index),
    );
  }

  console.log(trailerList);

  return (
    trailerList?.length > 0 && (
      <>
        {trailerList.length > 1 ? (
          <Title>{i18n.t(`Information from the ${tag}s`)}</Title>
        ) : (
          <Title>{i18n.t(`Information from the ${tag}`)}</Title>
        )}

        {trailerList.map((trailer, i) => {
          return (
            <DriverBlock key={i}>
              <SubTitle>
                {i === 0
                  ? i18n.t('Trailer')
                  : `${i18n.t('Additional trailer')} (${i})`}
              </SubTitle>
              <StyledSection background>
                {trailer.map(
                  ({
                    id,
                    rules,
                    title,
                    error_messages,
                    description,
                    insurance_type_tags,
                    field,
                    tag,
                  }) => {
                    return (
                      <StyledDiv
                        key={id}
                        span={getSpanLenght(id)}
                        width={getElementwidth(id)}
                      >
                        <InputSelector
                          description={
                            description && description[i18n.language]
                          }
                          typeTags={insurance_type_tags}
                          key={id}
                          rules={rules}
                          questionErrors={questionErrors}
                          name={id}
                          field={field}
                          errorMessages={error_messages}
                          title={title?.[i18n.language]}
                          tag={tag}
                        />
                      </StyledDiv>
                    );
                  },
                )}
              </StyledSection>
            </DriverBlock>
          );
        })}
      </>
    )
  );
};

const DriverBlock = styled.div`
  margin-bottom: 2rem;
`;

const StyledDiv = styled.div`
  grid-column: span ${({ span }) => span};
  width: ${({ width }) => width};
  h3 {
    color: #8990a3;
    font-weight: 600;
    letter-spacing: 0.01em;
    font-size: 14px;
  }
`;

const StyledSection = styled(Section.Content)`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  column-gap: 36px;
`;

const Title = styled.h2`
  font-size: 2.1rem;
  color: #0e0e0e;
  font-weight: 700;
  margin: 1rem 0;
  margin-top: 3rem;
`;

const SubTitle = styled.h3`
  font-size: 1.6rem;
  color: #8990a3;
  font-weight: 500;
`;

ProFlowQuestionsTrailer.propTypes = {
  taggedQuestions: shape().isRequired,
  allQuestions: shape().isRequired,
  questionErrors: array,
  tag: string,
};
export default ProFlowQuestionsTrailer;
